export const tableTheme = {
  colors: {
    primary: '#525f7f',
    secondary: '#8898aa',
    border: '#e9ecef',
    textPrimary: '#5f5f7f',
    textSecondary: '#5f5f80',
    background: '#f8f9fa'
  },
  spacing: {
    small: '0.2rem',
    medium: '0.5rem',
    large: '1rem'
  },
  fontSize: {
    small: '0.65rem',
    medium: '0.8125rem',
    large: '1rem'
  },
  fontWeight: {
    normal: 400,
    bold: 600
  }
};
